module.exports = __webpack_public_path__ + "img/careerservices.0a7dae19.jpg";